// extracted by mini-css-extract-plugin
export default {"dayViewWrap":"eventBody-module--day-view-wrap--jZjLR"};